export const getText = (elem: string | Element) => {
  if (typeof elem === 'string') {
    // 创建一个临时的 DOM 元素容器
    const tempDiv = document.createElement('div');

    // 将字符串设置为容器的 innerHTML，解析为 DOM 结构
    tempDiv.innerHTML = elem;

    // 获取解析后 DOM 元素的文本内容
    const text = tempDiv.textContent || '';
    return text;
  } else {
    return elem.textContent || '';
  }
}